export const SET_INITIAL_DATA = 'SET_INITIAL_DATA'
export const GET_INITIAL_DATA = 'GET_INITIAL_DATA'

export const SET_INVOICE_GROUP_COUNT = 'SET_INVOICE_GROUP_COUNT'